import React from "react";
import PropTypes from "prop-types";
import { isReadOnlyMode } from "../../../helpers/readOnlyMode";

/**
 * 列尾操作按鈕組（Figma DCK-05 機櫃 86:19556、2128:24170／24226 的「操作」欄）。
 *
 * 設計稿是三顆並排的 icon 按鈕(檢視 bx-show / 編輯 bx-edit-alt / 刪除 bx-trash),
 * Gray/200 底、圓角 10、字符 20px、整欄靠右;刪除使用 danger 色。
 * 唯讀權限仍顯示編輯與刪除，但以 disabled 狀態呈現;不是「⋯」下拉。
 * 動作多於三個的頁面仍可用 <RowActions>。
 *
 *   <RowIconActions items={[
 *     { label: "檢視", icon: "bx-show", onClick },
 *     { label: "編輯", icon: "bx-edit-alt", onClick, disabled },
 *     { label: "刪除", icon: "bx-trash", onClick, danger: true },
 *   ]} />
 */
/**
 * UAT 唯讀模式(helpers/readOnlyMode)下列尾只留這些動作。
 * 用「白名單」而不是黑名單:漏列一個寫入動作的後果是它跑到驗收站上,
 * 漏列一個唯讀動作的後果只是少一顆檢視鍵 —— 前者貴得多。
 */
const READ_ONLY_KEEP = new Set(["檢視"]);

export const RowIconActions = ({ items = [] }) => (
  <div className="dck-row-icons">
    {items
      .filter(Boolean)
      .filter((it) => !isReadOnlyMode() || READ_ONLY_KEEP.has(it.label))
      .map((it) => (
      <button
        key={it.label}
        type="button"
        className={`dck-row-icon${it.danger ? " is-danger" : ""}`}
        title={it.label}
        aria-label={it.label}
        disabled={it.disabled}
        onClick={it.onClick}
      >
        <i className={`bx ${it.icon}`} />
      </button>
    ))}
  </div>
);
RowIconActions.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
      onClick: PropTypes.func,
      disabled: PropTypes.bool,
      danger: PropTypes.bool,
    })
  ),
};

export default RowIconActions;
